/**
 * Latest-wins ordering for meal-plan list fetches, shared across every
 * surface that loads the list (dashboard, history page, the plan page's
 * delete/undo refresh).
 *
 * Mutation flows can have two list fetches in flight at once — e.g. the
 * refetch started right after a delete, and the refetch started by that
 * delete's Undo. On a slow network the earlier (pre-restore) response can
 * resolve last; applying it would wipe the restored plan from both the UI
 * and the session cache, where it would stick until a full reload. Callers
 * take a token before fetching and discard their response — no setState, no
 * cache write — if a newer fetch has started since.
 */

let latestFetchToken = 0;

/** Call before starting a list fetch; keep the returned token. */
export const nextMealPlansFetch = (): number => ++latestFetchToken;

/** True while no newer list fetch has started since the token was taken. */
export const isLatestMealPlansFetch = (token: number): boolean =>
  token === latestFetchToken;
